<template>
    <div class="section flex_child_3_3" :style="'min-height: calc(' + changeBrowserSize.height + ' - 650px);'">
        <div class="section_wrap row">
          <h6 class="--blue70 mb10">{{ $t('rehabilitation.record') }}</h6>
            <div v-if="detailsAndRecordComponentIdxProps === 1" class="reh_con_scroll rehab_record_list" style="height: 400px;">
                <ListTable v-if="this.refinedExerciseListProps.length > 0"
                           :headerItems="headerItems"
                           :itemRows="showRehabilitationRecord"
                />
                <div v-if="this.refinedExerciseListProps.length === 0" class="record_box">
                    {{ $t('rehabilitation.no_record')}}
                </div>
                <div v-else-if="this.showRehabilitationRecord.length === 0" class="record_box">
                    {{ $t('rehabilitation.no_record')}}
                </div>
            </div>
            <div v-if="detailsAndRecordComponentIdxProps === 0" class="record_box">
                <div>
                    {{ $t('rehabilitation.select_list_for_record')}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ListTable from "../../../../Table/listTable/index";

    export default {
      props: ['refinedExerciseListProps', 'selectedRowsProps', 'detailsAndRecordComponentIdxProps'],
      data() {
        return {
          headerItems: [
            {
              index: 0,
              keyTitle: this.$t('rehabilitation.start_time'),
              keyType: 'HeaderDefault',
              class: [''],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: ''
            },
            {
              index: 1,
              keyTitle: this.$t('rehabilitation.execution_time'),
              keyType: 'HeaderDefault',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: '',
            },
            {
              index: 2,
              keyTitle: this.$t('exercise.record.minAngle'),
              keyType: 'HeaderDefault',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: '',
            },
            {
              index: 3,
              keyTitle: this.$t('exercise.record.maxAngle'),
              keyType: 'HeaderDefault',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: '',
            },
            {
              index: 4,
              keyTitle: this.$t('exercise.record.reView'),
              keyType: 'HeaderDefault',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: '',
              style: {
                flexGrow: '6 !important',
              }
            },
          ],
        }
      },
      components: {
        ListTable,
      },
      computed: {
        showRehabilitationRecord() {
          const itemRows = [];

          const device = this.refinedExerciseListProps[this.selectedRowsProps].seqDeviceType;
          const position = this.refinedExerciseListProps[this.selectedRowsProps].exerciseGuide?.exerciseGuidePosition;

          for (let i = 0; this.refinedExerciseListProps[this.selectedRowsProps].recordList.length > i; i++) {
            const items = [];

            let values = {
              min: '',
              max: '',
            }

            if (device === 1) {
              values.min = Math.floor(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].iuppiterUsage?.iuppiterUsageMinAngle);
              values.max = Math.floor(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].iuppiterUsage?.iuppiterUsageMaxAngle);
            } else {
              if (position === 3) {
                values.min = Math.floor(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].iuppiterProUsage?.usageKneeMinAngle);
                values.max = Math.floor(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].iuppiterProUsage?.usageKneeMaxAngle);
              } else {
                values.min = Math.floor(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].iuppiterProUsage?.usageAnkleMinAngle);
                values.max = Math.floor(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].iuppiterProUsage?.usageAnkleMaxAngle);
              }
            }

            items.clickEvent = {
              func: () => {
                // This is intentional
              },
              params: [],
              key: 'none'
            };
            items.push({
              index: 0,
              keyTitle: '',
              keyType: 'Default',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.moment(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].deviceUsage.usageStartDatetime).locale(this.$t('country')).format('lll')
            });
            items.push({
              index: 1,
              keyTitle: '',
              keyType: 'Default',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.moment.utc(this.moment.duration(this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].deviceUsage.deviceUsageDuration, 'second').asMilliseconds()).format('HH:mm:ss')
            });
            items.push({
              index: 2,
              keyTitle: '',
              keyType: 'Default',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: values.min + '˚',
            });
            items.push({
              index: 3,
              keyTitle: '',
              keyType: 'Default',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: values.max + '˚',
            });
            items.push({
              index: 4,
              keyTitle: '',
              keyType: 'Default',
              class: [],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.refinedExerciseListProps[this.selectedRowsProps].recordList[i].exerciseCourse.exerciseFeedback,
              style: {
                flexGrow: '6 !important',
              }
            });
            itemRows.push(items);
          }
          return itemRows;
        },
        changeBrowserSize() {
          return this.$store.getters.getBrowserSize;
        },
      },
      methods: {}
    }
</script>
<style lang="scss">
    .flex_child_3_3 {
        -webkit-box-flex: 3;
        -ms-flex: 3 3 10rem;
        flex: 3 3 10rem;
        overflow: hidden;
    }

    .mt125 {
        margin-top: 125px;
    }

    .rehab_record_list {
      .table-container {
        grid-template-columns: 1fr;

        .table-header {
          position: sticky;
          top: 0;
          background: #f7f7f7;
          margin: 0;
        }

        .table-body {
          margin: 0;
        }
      }
    }

    .record_box {
        display: flex;justify-content: center;align-items: center;height: 150px;
    }
</style>